export default {
      id: "oc-zettakit-usage",
      viewBox: "0 0 636 635",
      url: __webpack_public_path__ + "sprite.svg#oc-zettakit",
      toString: function () {
        return this.url;
      }
    }